import React from "react";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import Container from "./Container";
import Section from "./Section";
import styled, { css } from "styled-components";

const VideoStyles = styled.div`
  ${({ ...props }) => css`
    .yt-lite {
      overflow: hidden;
      border-radius: ${props.$fullWidth ? '0' : '4px'}
    }
    @media (max-width: 577px) {
      .yt-lite {
        border-radius: 0
      }
    }
    .yt-lite > .lty-playbtn {
      width: 76px;
      height: 76px;
      border-radius: 50%;
      background-color: ${props.theme.colors.primary};
      opacity: 1;
      &::before {
        border-width: 16px 0 16px 24px;
        margin-left: 4px;
      }
    }
    .yt-lite:hover > .lty-playbtn {
      background-color: #2F3938;
    }
    .yt-lite.lyt-activated::before,
    .yt-lite.lyt-activated > .lty-playbtn {
      opacity: 0
    }
  `}
`;

const VideoWrapperStyles = styled.div`
  ${({ ...props }) => css`
    section {
      ${props.$fullWidth && !props.$hasTitle ? 'padding-top: 0;' : ''}
      ${props.$fullWidth ? 'padding-bottom: 0;' : ''}

      > div:has(article) {
        display: ${props.$fullWidth ? 'contents' : 'block'};
      }
    }

    @media (max-width: 577px) {
      section {
        padding-bottom: 0;
        
        > div:has(article) {
          display: contents
        }
      }
    }
  `}
`;

export const Video = ({ title, video, aspectWidth = 16, aspectHeight = 9, fullWidth = true, background = 'white' }) => {
  if (!video) {
    return <></>
  }

  // Get ID from URL
  const id = video.split("=")[1];

  if (!id) {
    return <></>
  }

  return (
    <VideoWrapperStyles
      $fullWidth={fullWidth}
      $hasTitle={title}
    >
      <Section
        grey={background === 'grey'}
        heading={title}
      >
        <Container>
          <VideoStyles
            $fullWidth={fullWidth}
          >
            <LiteYouTubeEmbed
              id={id}
              params="rel=0"
              poster="maxresdefault"
              webp={true}
              aspectWidth={aspectWidth}
              aspectHeight={aspectHeight}
            />
          </VideoStyles>
        </Container>
      </Section>
    </VideoWrapperStyles>
  )
};
